module.exports = __webpack_public_path__ + "img/shield.10c79655.jpeg";